import { lazy } from "react";
import LoginMiddleware from "@/middlewares/login-middlewares";

export const routes: Array<AppConfigs.RouteConfig> = [
  {
    path: "/",
    id: "layout",
    element: lazy(() => import("../layout")),
    children: [
      {
        path: "/",
        id: "home",
        title: "首页",
        redirect: "/map-download",
      },
      {
        path: "/app",
        id: "app",
        title: "APP下载",
        element: lazy(() => import("@/pages/app")),
      },
      {
        path: "/qr/*",
        id: "qrcode",
        title: "二维码",
        element: lazy(() => import("@/pages/qrcode")),
      },
      {
        path: "/login",
        id: "login",
        title: "登录",
        element: lazy(() => import("@/pages/login")),
      },
      {
        path: "/map-download",
        id: "map_download",
        title: "地图下载",
        element: lazy(() => import("@/pages/map-download")),
        middlewares: [LoginMiddleware],
      },
      {
        path: "/xlsx-to-json",
        id: "xlsx_to_json",
        title: "Xlsx To Json",
        element: lazy(() => import("@/pages/xlsx-to-json")),
      },
      {
        path: "/sport-game",
        id: "sport_game",
        title: "Sport Game",
        element: lazy(() => import("@/pages/sport-game")),
      },
    ],
  },
  {
    path: "/500",
    id: "page_server_error",
    title: "500",
    element: lazy(() => import("@/pages/500")),
  },
  {
    path: "*",
    id: "page_not_found",
    title: "404",
    element: lazy(() => import("@/pages/404")),
  },
];
